import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-cfet-carousel',
    templateUrl: './cfet-carousel.component.html',
    styleUrls: ['./cfet-carousel.component.scss'],
    standalone: false
})
export class CfetCarouselComponent {
  customOptions: OwlOptions = {
    loop: true,
    margin: 10,
    autoplay: true,
    responsive: {
      0: {
        items: 1
      }
    },
    nav: true,
    navSpeed: 5000
  };


}
